import { render, staticRenderFns } from "./PrintPage.vue?vue&type=template&id=6ec247e9&scoped=true&"
import script from "./PrintPage.vue?vue&type=script&lang=ts&"
export * from "./PrintPage.vue?vue&type=script&lang=ts&"
import style0 from "./PrintPage.vue?vue&type=style&index=0&id=6ec247e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec247e9",
  null
  
)

export default component.exports